module.exports = __webpack_public_path__ + "static/media/coolfront_logo.9fb7e6e7.png";